import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import AddChurchFields from "../../components/Resource/AddResourceField";
import { useLocation } from "react-router-dom";

const ChurchModal = ({ isOpen, onClose,rowData,church }) => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  // lock body scroll when modal open

  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = isOpen ? "hidden" : prev;
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  // keep component mounted so transitions can run
  return (
    <div
      className={`fixed inset-0 z-[100] flex justify-end items-center ${
        isOpen ? "" : "pointer-events-none"
      }`}
      aria-hidden={!isOpen}
    >
      {/* Backdrop — fades in/out and applies blur. Clicking it closes modal */}
      <div
        onClick={onClose}
        className={`absolute inset-0 bg-black/50 backdrop-blur-sm transition-opacity duration-300 ease-out ${
          isOpen ? "opacity-100" : "opacity-0"
        }`}
      />

      {/* Modal panel — slides in/out from right */}
      <div
        onClick={(e) => e.stopPropagation()} // prevent backdrop click when clicking inside modal
        role="dialog"
        aria-modal="true"
        className={`relative bg-[#1f1f1f] text-white shadow-2xl transform transition-all duration-500 ease-in-out rounded-md
          ${isOpen ? "translate-x-0 opacity-100" : "translate-x-full opacity-0"}`}
        style={{ width: "85%", height: "90%" }}
      >
        {/* Header (sticky so it doesn't scroll away) */}
        <div className="flex justify-between items-center p-4 border-b border-gray-700 sticky top-0 bg-[#1f1f1f] z-10">
          <h2 className="text-lg font-semibold">Add Resource</h2>
          <button onClick={onClose} className="p-1">
            <IoCloseOutline className="text-2xl" />
          </button>
        </div>

        {/* Scrollable content area (header excluded) */}
        <div className="p-4 overflow-y-auto h-[calc(100%-64px)]">
          <div className="MAIN-CONTENT flex flex-col gap-4">
            <AddChurchFields church={church} data={location?.state} setLoading={setLoading} rowData={rowData?rowData:{}} onClose={onClose}/>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChurchModal;
